import { Skeleton } from '@common/components';

/**
 * HometownNews / PolicyInfo 검색 결과 카드 (`SearchContentsCard`)의 스켈레톤.
 */
function SearchContentsCardSkeleton() {
  return (
    <div
      role="status"
      aria-label="콘텐츠 카드 로딩 중"
      className="flex flex-col gap-8 rounded-medium border border-Gray-100 bg-Gray-white px-24 py-20 mobile-tablet:gap-12 mobile-tablet:rounded-none mobile-tablet:border-0"
    >
      <div className="flex items-start gap-24">
        <div className="flex min-w-0 flex-1 flex-col gap-8 mobile-tablet:gap-12">
          <Skeleton className="h-24 w-3/4 rounded-xxsmall mobile-tablet:h-20" />
          <div className="flex flex-col gap-4">
            <Skeleton className="h-16 w-full rounded-xxsmall" />
            <Skeleton className="h-16 w-5/6 rounded-xxsmall" />
          </div>
          <Skeleton className="h-16 w-60 rounded-xxsmall" />
        </div>
        <Skeleton className="size-96 shrink-0 rounded-small mobile-tablet:size-68 mobile-tablet:self-center" />
      </div>
    </div>
  );
}

interface SearchContentsCardSkeletonListProps {
  count: number;
}

export function SearchContentsCardSkeletonList({
  count,
}: SearchContentsCardSkeletonListProps) {
  return (
    <ul
      aria-busy="true"
      className="flex flex-col gap-12 pb-20 mobile-tablet:gap-0 mobile-tablet:divide-y mobile-tablet:divide-Gray-100 mobile-tablet:pb-0"
    >
      {Array.from({ length: count }, (_, index) => (
        <li key={index}>
          <SearchContentsCardSkeleton />
        </li>
      ))}
    </ul>
  );
}
